import { ApiError } from '@/api/client';
export const EMPTY_ORDER_SEARCH = {
    order_id: '',
    payment_id: '',
    provider_charge_id: '',
    user_id: '',
    payment_system: '',
    state: '',
    created_from: '',
    created_to: '',
};
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const LOCAL_DATE_TIME_RE = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})(?::(\d{2}))?$/;
export function validateOrderSearch(draft) {
    const errors = {};
    const uuids = [
        ['order_id', 'Введите UUID заказа полностью'],
        ['payment_id', 'Введите UUID платежа полностью'],
        ['user_id', 'Введите UUID пользователя полностью'],
    ];
    for (const [field, message] of uuids) {
        const value = draft[field].trim();
        if (value && !UUID_RE.test(value))
            errors[field] = message;
    }
    if (draft.provider_charge_id.trim().length > 255) {
        errors.provider_charge_id = 'Не больше 255 символов';
    }
    if (draft.created_from &&
        draft.created_to &&
        new Date(draft.created_from).getTime() > new Date(draft.created_to).getTime()) {
        errors.created_from = 'Начало периода не может быть позже конца';
    }
    return errors;
}
export function localDateTimeToIso(value, timezoneOffsetMinutes) {
    const match = LOCAL_DATE_TIME_RE.exec(value);
    if (!match)
        return undefined;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime()))
        return undefined;
    const offset = -(timezoneOffsetMinutes ?? parsed.getTimezoneOffset());
    const abs = Math.abs(offset);
    const pad = (part) => String(part).padStart(2, '0');
    const zone = `${offset >= 0 ? '+' : '-'}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
    return `${match[1]}T${match[2]}:${match[3] ?? '00'}${zone}`;
}
export function orderSearchParams(draft) {
    const params = {};
    for (const field of [
        'order_id',
        'payment_id',
        'provider_charge_id',
        'user_id',
        'payment_system',
        'state',
    ]) {
        const value = draft[field].trim();
        if (value)
            params[field] = value;
    }
    const createdFrom = localDateTimeToIso(draft.created_from);
    const createdTo = localDateTimeToIso(draft.created_to);
    if (createdFrom)
        params.created_from = createdFrom;
    if (createdTo)
        params.created_to = createdTo;
    return params;
}
export function orderSearchApiErrors(error) {
    if (!(error instanceof ApiError) || error.status !== 422)
        return {};
    const detail = error.body?.detail;
    if (!Array.isArray(detail))
        return {};
    const result = {};
    for (const item of detail) {
        if (!item || typeof item !== 'object')
            continue;
        const { loc, msg } = item;
        if (!Array.isArray(loc) || typeof msg !== 'string')
            continue;
        const field = loc.at(-1);
        if (typeof field === 'string' && field in EMPTY_ORDER_SEARCH) {
            result[field] = msg.replace(/^Value error,\s*/u, '');
        }
    }
    return result;
}
